var React = require('react');

function IconFolderSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M927.2 227.5H594.1l-59.7-98.9H100.5c-17.8 0-32.7 14.8-32.7 33.1v700.7c0 18.6 14.7 33.1 32.8 33.1h827c18.1 0 32.8-14.7 32.8-32.9V260.3c0-17.9-14.9-32.8-33.2-32.8z"}));
}

IconFolderSolid.displayName = "IconFolderSolid";

IconFolderSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconFolderSolid;

IconFolderSolid.default = IconFolderSolid;
